// import Vuex from 'vuex'
// import createPersistedState from 'vuex-persistedstate'
// import VuexPersistence from 'vuex-persist'
// import { get, set, del } from 'idb-keyval'

// // modules
// import account from './account'
// import ui from './ui'
// import campaign from './campaign'
// import experiences from './experiences'
// import experience from './experience'
// import sponsorshipRequests from './sponsorshipRequests'
// import teamManagement from './teamManagement'
// import staffManagement from './staffManagement'
// import googlePlaces from './googlePlaces'
// import budgets from './budgets'
// import assets from './assets'
// import campaignProfile from './campaignProfile'
// import app from './app'
// import basket from './basket'

// // check if asyncStorage is set before mutate or getters
// const basketHydrationPlugin = (store) => {
//   let hydrated = false;

//   setTimeout(() => {
//     if (!hydrated) {
//       console.log('Hydration fallback triggered');
//       store.commit('basket/setBasketLoading', false);
//       hydrated = true;
//     }
//   }, 1000);

//   store.subscribe((mutation) => {
//     if (
//       !hydrated &&
//       mutation.type.startsWith('basket/') &&
//       mutation.type !== 'basket/setBasketLoading'
//     ) {
//       console.log('Hydration mutation triggered:', mutation.type);
//       store.commit('basket/setBasketLoading', false);
//       hydrated = true;
//     }
//   });
// };

// // IndexedDB storage for vuex-persist
// const asyncStorage = {
//   getItem: key => {
//     return get(key).then(value => {
//       try {
//         return typeof value === 'string' ? JSON.parse(value) : value;
//       } catch {
//         return value;
//       }
//     });
//   },
//   setItem: (key, value) => set(key, JSON.stringify(value)),
//   removeItem: key => del(key),
// }

// // vuex-persist for basket only
// const basketPersist = new VuexPersistence({
//   key: 'basket',
//   storage: asyncStorage,
//   asyncStorage: true,
//   modules: ['basket'],
//   restoreState: (key, storage) => storage.getItem(key),
// })

// export default new Vuex.Store({
//   modules: {
//     account,
//     ui,
//     campaign,
//     experience,
//     sponsorshipRequests,
//     googlePlaces,
//     budgets,
//     assets,
//     teamManagement,
//     staffManagement,
//     experiences,
//     campaignProfile,
//     app,
//     basket,
//   },
//   plugins: [
//     createPersistedState({
//       paths: [
//         'account.venueIdentifiers',
//         'account.user',
//         'account.currentUser',
//         'account.bookFor',
//         'account.userStates',
//         'account.myCountry',
//         'account.myCountryDetails',
//         'account.venueWaitingReview',
//         'account.isSpecificTypeAttatch',
//         'campaign.status',
//         'campaign.id',
//         'campaign',
//         'campaignProfile',
//         'experience.createBookingData',
//         'experience.publicBookingData',
//         'experience.isEditBookingMode',
//         'experiences.reschedule',
//         'ui.popupMyVenues',
//       ],
//     }),
//     basketPersist.plugin, // vuex-persist for basket (IndexedDB)
//     basketHydrationPlugin
//   ],
//   strict: false,
// })



import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
// modules
import account from './account'
import ui from './ui'
import campaign from './campaign'
import experiences from './experiences'
import experience from './experience'
import sponsorshipRequests from './sponsorshipRequests'
import teamManagement from './teamManagement'
import staffManagement from './staffManagement'
import googlePlaces from './googlePlaces'
import budgets from './budgets'
import assets from './assets'
import campaignProfile from './campaignProfile'
import app from './app'
import basket from './basket'

// const debug = process.env.SERVER_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    account,
    ui,
    campaign,
    experience,
    sponsorshipRequests,
    googlePlaces,
    budgets,
    assets,
    teamManagement,
    staffManagement,
    experiences,
    campaignProfile,
    app,
    basket,
  },
  plugins: [
    createPersistedState({
      paths: [
        'account.venueIdentifiers',
        'account.user',
        'account.currentUser',
        'account.bookFor',
        'account.userStates',
        'account.myCountry',
        'account.myCountryDetails',
        'account.venueWaitingReview',
        'account.isSpecificTypeAttatch',
        'account.parentBrandSelected',
        'campaign.status',
        'campaign.id',
        'campaign',
        'campaignProfile',
        'experience.createBookingData',
        'experience.publicBookingData',
        'experience.isEditBookingMode',
        'experiences.reschedule',
        'basket',
        'ui.popupMyVenues',
      ],
    }),
  ],
  strict: false,
})
